var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('button');
import { breakpoints, theme } from '@shapeable/theme';
import { Icon } from './icon';
import { DottedChevronRightIcon } from './dotted-chevron-right-icon';
import { DottedChevronLeftIcon } from './dotted-chevron-left-icon';
import { withOwnProvider } from '../../utils/with-own-provider';
import { useComponentColor } from '../../hooks/use-component-color';
export var ButtonDefaultProps = {
  tag: 'button',
  variant: 'default',
  icon: DottedChevronRightIcon,
  reversedIcon: DottedChevronLeftIcon,
  type: 'button'
};
export var ButtonVariantIconSizes = {
  slim: 16,
  default: 24
};
export var ButtonVariantBasePadding = {
  slim: [2, 4],
  default: [3, 4]
};
export var ButtonVariantPadding = {
  slim: [2, 4],
  default: [3, 4]
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", ";\n    font-weight: 500;\n    cursor: pointer;\n    font-family: ", ";\n    font-size: ", ";\n    align-items: center;\n    display: flex;\n    transition-duration: 0.2s;\n    transition-property: color, border-color;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    text-decoration: none;\n    text-transform: uppercase;\n    \n    justify-content: space-between;\n  "], ["\n    ", ";\n    font-weight: 500;\n    cursor: pointer;\n    font-family: ", ";\n    font-size: ", ";\n    align-items: center;\n    display: flex;\n    transition-duration: 0.2s;\n    transition-property: color, border-color;\n\n    ", "\n\n    ", "\n\n    ", "\n\n    ", "\n\n    text-decoration: none;\n    text-transform: uppercase;\n    \n    justify-content: space-between;\n  "])), theme.REMOVE_BUTTON_STYLE(), theme.FONT('sans'), theme.FONT_SIZE(14), function (_a) {
    var isReversed = _a.isReversed,
        variant = _a.variant;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      flex-direction: ", ";\n      padding: ", " ", ";\n    "], ["\n      flex-direction: ", ";\n      padding: ", " ", ";\n    "])), isReversed ? 'row-reverse' : 'row', theme.UNIT(ButtonVariantBasePadding[variant][0]), theme.UNIT(ButtonVariantBasePadding[variant][1]));
  }, function (_a) {
    var _disabled = _a._disabled;
    return _disabled && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      cursor: default;\n    "], ["\n      cursor: default;\n    "])));
  }, function (_a) {
    var _color = _a._color,
        _hoverColor = _a._hoverColor,
        _disabled = _a._disabled;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      ", ";\n      color: ", ";\n      border: 2px dotted ", ";\n      opacity: ", ";\n    "], ["\n      ", ";\n      color: ", ";\n      border: 2px dotted ", ";\n      opacity: ", ";\n    "])), theme.FILL(_color), theme.COLOR(_color), theme.COLOR(_color), _disabled ? 0.2 : 1.0);
  }, function (_a) {
    var _disabled = _a._disabled,
        _hoverColor = _a._hoverColor;
    return !_disabled && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      &:hover {\n        ", ";\n        color: ", ";\n        border-color: ", ";\n      }\n    "], ["\n      &:hover {\n        ", ";\n        color: ", ";\n        border-color: ", ";\n      }\n    "])), theme.FILL(_hoverColor), theme.COLOR(_hoverColor), theme.COLOR(_hoverColor));
  }),
  tablet: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (_a) {
    var variant = _a.variant;
    return css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      padding: ", " ", ";\n    "], ["\n      padding: ", " ", ";\n    "])), theme.UNIT(ButtonVariantPadding[variant][0]), theme.UNIT(ButtonVariantPadding[variant][1]));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-left: ", ";\n    flex-shrinK: 0;\n    \n    path, rect, circle, polygon {\n      transition: fill 0.2s ease-in-out;\n    }\n\n    ", "\n\n    ", "\n  "], ["\n    margin-left: ", ";\n    flex-shrinK: 0;\n    \n    path, rect, circle, polygon {\n      transition: fill 0.2s ease-in-out;\n    }\n\n    ", "\n\n    ", "\n  "])), theme.UNIT(4), function (_a) {
    var isReversed = _a.isReversed;
    return isReversed && css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n      margin-right: ", ";\n      margin-left: 0;\n    "], ["\n      margin-right: ", ";\n      margin-left: 0;\n    "])), theme.UNIT(4));
  }, function (_a) {
    var variant = _a.variant;
    return css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      height: ", "px;\n      width: ", "px;\n    "], ["\n      height: ", "px;\n      width: ", "px;\n    "])), ButtonVariantIconSizes[variant], ButtonVariantIconSizes[variant]);
  })
});
var IconBodyStyles = breakpoints({
  base: css(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    ", "\n  "], ["\n    display: flex;\n    align-items: center;\n    ", "\n  "])), function (props) {
    return css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      flex-direction: ", ";\n    "], ["\n      flex-direction: ", ";\n    "])), props.isReversed ? 'row-reverse' : 'row');
  })
});
var LabelsStyles = breakpoints({
  base: css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var SubLabelStyles = breakpoints({
  base: css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    font-weight: 300;\n    display: block;\n  "], ["\n    font-weight: 300;\n    display: block;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.span(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  IconBody: styled.span.attrs(cls.attr('icon-body'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), IconBodyStyles),
  Icon: styled(Icon)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  Labels: styled.span.attrs(cls.attr('labels'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), LabelsStyles),
  SubLabel: styled.span.attrs(cls.attr('sub-label'))(templateObject_19 || (templateObject_19 = __makeTemplateObject(["", ""], ["", ""])), SubLabelStyles)
};
export var Button = function Button(props) {
  var className = props.className,
      subLabel = props.subLabel,
      children = props.children,
      isReversed = props.isReversed,
      tag = props.tag,
      type = props.type,
      disabled = props.disabled,
      preIcon = props.preIcon,
      onClick = props.onClick,
      variant = props.variant;
  var Icon = isReversed ? props.reversedIcon : props.icon;
  var clickProps = disabled ? {} : {
    onClick: onClick
  };
  var iconElement = React.createElement(My.Icon, {
    variant: subLabel ? 'default' : variant,
    isReversed: isReversed
  }, React.createElement(Icon, null));
  var color = useComponentColor({
    cls: cls,
    prop: props.color,
    fallbacks: ['dark']
  });
  var hoverColor = useComponentColor({
    cls: cls,
    sub: 'hover',
    prop: props.hoverColor,
    fallbacks: ['link-hover', 'mid-brand']
  });
  return (
    /* @ts-ignore */
    React.createElement(My.Container, __assign({
      variant: variant
    }, clickProps, {
      isReversed: isReversed,
      disabled: disabled,
      _disabled: disabled,
      as: tag,
      type: type,
      _color: color,
      _hoverColor: hoverColor,
      className: cls.name(className)
    }), subLabel ? React.createElement(My.Labels, null, children, React.createElement(My.SubLabel, null, subLabel)) : children, preIcon ? React.createElement(My.IconBody, {
      variant: variant,
      isReversed: isReversed
    }, preIcon, iconElement) : iconElement)
  );
};
Button.cls = cls;
Button.defaultProps = ButtonDefaultProps;
export var ButtonReplaceable = withOwnProvider(Button);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19;